import type { MembershipAction, ProfileOverlay } from "../profileOverlay";
import { EditMembershipForm } from "./EditMembershipForm";
import { EndMembershipForm } from "./EndMembershipForm";
import { ExtendTrialForm } from "./ExtendTrialForm";
import { MembershipDetails } from "./MembershipDetails";
import { UpgradeMembershipForm } from "./UpgradeMembershipForm";

export function MembershipForm({
    action,
    onClose,
    onOpen,
}: {
    action: MembershipAction;
    onClose: () => void;
    onOpen: (next: ProfileOverlay) => void;
}) {
    switch (action) {
        case "create":
            return <EditMembershipForm mode="create" onClose={onClose} />;
        case "endTrial":
            return <EndMembershipForm kind="trial" onClose={onClose} />;
        case "cancel":
            return <EndMembershipForm kind="paid" onClose={onClose} />;
        case "details":
            return (
                <MembershipDetails
                    onClose={onClose}
                    onCancelRenewal={() =>
                        onOpen({ type: "membership", action: "cancel" })
                    }
                />
            );
        case "extendTrial":
            return <ExtendTrialForm onClose={onClose} />;
        case "upgrade":
            return <UpgradeMembershipForm onClose={onClose} />;
        case "edit":
            return <EditMembershipForm onClose={onClose} />;
        default: {
            const _exhaustive: never = action;
            return _exhaustive;
        }
    }
}
